import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BoundaryIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.boundaryIcon}`}
        data-testid={testId}
        fill='none'
        height='31'
        viewBox='0 0 28 31'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M26.1476 28.5059C25.1245 28.5059 24.2952 29.0642 24.2952 29.7529C24.2952 30.4417 25.1245 31 26.1476 31C27.1707 31 28 30.4417 28 29.7529C28 29.0642 27.1707 28.5059 26.1476 28.5059ZM26.1476 28.9735C26.7986 28.9735 27.3264 29.3223 27.3265 29.7528C27.3265 30.1832 26.7986 30.5323 26.1476 30.5323C25.4965 30.5322 24.9688 30.1832 24.9688 29.7528C24.9689 29.3223 25.4966 28.9735 26.1476 28.9735Z'
            fill='currentColor'
        />

        <path
            d='M1.91209 28.3053C0.856051 28.3053 -1.10862e-06 28.8817 -1.10862e-06 29.5926C3.26631e-05 30.3035 0.856071 30.8798 1.91209 30.8798C2.96814 30.8798 3.82432 30.3036 3.82435 29.5926C3.82435 28.8817 2.96817 28.3053 1.91209 28.3053ZM1.91209 28.7879C2.58411 28.7879 3.12884 29.1482 3.12888 29.5925C3.12888 30.0368 2.58414 30.397 1.91209 30.397C1.24006 30.397 0.695306 30.0368 0.695306 29.5925C0.695348 29.1482 1.24008 28.7879 1.91209 28.7879Z'
            fill='currentColor'
        />

        <path
            d='M9.57697 25.1657C8.52091 25.1657 7.66488 25.7421 7.66488 26.4531C7.6649 27.164 8.52092 27.7404 9.57697 27.7404C10.633 27.7404 11.4892 27.164 11.4892 26.4531C11.4892 25.7421 10.633 25.1657 9.57697 25.1657ZM9.57697 25.6484C10.249 25.6484 10.7939 26.0086 10.7939 26.4529C10.7939 26.8973 10.249 27.2575 9.57697 27.2575C8.90494 27.2574 8.36018 26.8972 8.36018 26.4529C8.36024 26.0086 8.90497 25.6484 9.57697 25.6484Z'
            fill='currentColor'
        />

        <path
            d='M24.1725 19.9845C23.3238 19.9845 22.6357 20.4129 22.6357 20.9412C22.6358 21.4695 23.3238 21.8978 24.1725 21.8978C25.0213 21.8978 25.7093 21.4695 25.7093 20.9412C25.7093 20.4129 25.0213 19.9845 24.1725 19.9845ZM24.1727 20.3946C24.664 20.3946 25.0623 20.6393 25.0623 20.9412C25.0623 21.2431 24.6641 21.4878 24.1727 21.4879C23.6813 21.4879 23.2829 21.2431 23.2829 20.9412C23.283 20.6393 23.6813 20.3946 24.1727 20.3946Z'
            fill='currentColor'
        />

        <path
            d='M3.5816 19.9592C2.71041 19.9592 2.0042 20.3988 2.00415 20.9411C2.0042 21.4833 2.71041 21.9231 3.5816 21.9231C4.4528 21.9231 5.15916 21.4833 5.15921 20.9411C5.15916 20.3988 4.4528 19.9592 3.5816 19.9592ZM3.5816 20.3799C4.08599 20.38 4.49496 20.6312 4.49496 20.9411C4.4949 21.2509 4.08596 21.5022 3.5816 21.5022C3.07724 21.5022 2.66845 21.2509 2.6684 20.9411C2.6684 20.6312 3.07721 20.38 3.5816 20.3799Z'
            fill='currentColor'
        />

        <path
            d='M4.64644 20.2332L4.63422 21.5164L23.149 21.6801L23.1612 20.3969L4.64644 20.2332Z'
            fill='currentColor'
        />

        <path
            d='M23.5559 21.6722L25.2384 28.8929L26.5383 28.6118L24.8556 21.3912L23.5559 21.6722Z'
            fill='currentColor'
        />

        <path
            d='M11.157 25.9058L10.8226 27.313L24.6428 30.3608L24.9772 28.9535L11.157 25.9058Z'
            fill='currentColor'
        />

        <path
            d='M3.6839 29.9678L8.81771 27.5802L8.16635 26.2801L3.0324 28.6677L3.6839 29.9678Z'
            fill='currentColor'
        />

        <path
            d='M1.50663 28.596L2.82277 28.7934L3.98834 21.5751L2.6722 21.3777L1.50663 28.596Z'
            fill='currentColor'
        />

        <path
            d='M13.6756 0C8.95467 5.64449e-05 5.12766 3.66904 5.12764 8.19485C5.12766 10.2331 5.87452 12.1122 6.78737 13.5113L6.78721 13.5115L13.717 24.5444L20.6467 13.4715L6.82884 13.5113L20.6468 13.4714C21.7257 11.5726 22.2236 10.2331 22.2236 8.19485C22.2236 3.66901 18.3965 0 13.6756 0ZM13.6557 4.2417C15.9559 4.24172 17.8206 6.038 17.8206 8.2539C17.8206 10.4698 15.9559 12.2662 13.6557 12.2663C11.3555 12.2663 9.49071 10.4698 9.49071 8.2539C9.49073 6.03799 11.3555 4.2417 13.6557 4.2417Z'
            fill='currentColor'
        />
    </svg>
);

export default BoundaryIcon;
